import { render, staticRenderFns } from "./DbConnections.vue?vue&type=template&id=2ce1c056&scoped=true&"
import script from "./DbConnections.vue?vue&type=script&lang=ts&"
export * from "./DbConnections.vue?vue&type=script&lang=ts&"
import style0 from "./DbConnections.vue?vue&type=style&index=0&id=2ce1c056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce1c056",
  null
  
)

export default component.exports